import React from "react";
import "./KurvFooter.scss";

const KurvFooter = ({ variant }) => {
    return (
        <div className={`kurv-footer ${variant === "dashboard" ? "kurv-footer-dashboard" : ""}`}>
            <div className="kurv-footer-links">
                <a
                    href="https://kurvpay.com/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Policy
                </a>
                <span className="separator">|</span>
                <a
                    href="https://kurvpay.com/terms/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Terms of Use
                </a>
                <span className="separator">|</span>
                <a
                    href="https://kurvpay.com/contact/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Contact
                </a>
            </div>
            <div className="kurv-copy-right">
                <p>Copyright © Kurv. All Rights Reserved.</p>
            </div>
        </div>
    );
};

export default KurvFooter;
